import React, { useState } from "react"
import { RfidActivationLayout } from "layouts/rfid/rfidActivationLayout.tsx"
import { Autocomplete, TextField, Typography, Box } from "@mui/material"
import { OreveButton } from "components/button/OreveButton.tsx"
import type { ListRfidInfo, RfidInfo } from "types/rfid"

interface Step1Props {
    inactiveRfidCardSource: ListRfidInfo
    validateCard: (card: RfidInfo) => void
    goBackToList: () => void
}
export const Step1: React.FC<Step1Props> = ({
    inactiveRfidCardSource,
    validateCard,
    goBackToList,
}) => {
    const [chosenCard, setChosenCard] = useState<RfidInfo>()

    return (
        <RfidActivationLayout
            step={1}
            totalSteps={4}
            goBackToList={goBackToList}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "1.5rem",
                    marginBottom: { xs: "4rem", md: "8rem" },
                    width: "100%",
                }}
            >
                <Typography variant="labelLarge" textAlign="center">
                    Saisissez le numéro de carte RFID
                </Typography>

                <Autocomplete
                    //open={true}
                    //disablePortal
                    data-cy="rfid__activation--cardlist"
                    sx={{ width: { xs: "100%", sm: "350px", md: "400px" } }}
                    options={
                        Array.isArray(inactiveRfidCardSource)
                            ? inactiveRfidCardSource
                            : []
                    }
                    onChange={(_evt, newValue) =>
                        setChosenCard(newValue ?? undefined)
                    }
                    getOptionLabel={(option) => option?.rfidNumber || ""}
                    renderInput={(params) => (
                        <TextField {...params} label="Numéro de carte" />
                    )}
                    renderOption={(props, option, { index }) => {
                        const { key, ...optionProps } = props
                        return (
                            <li
                                key={key}
                                {...optionProps}
                                data-cy={`rfid__activation--carditem-${index + 1}`}
                            >
                                {option.rfidNumber}
                            </li>
                        )
                    }}
                />

                <OreveButton
                    data-cy="rfid__activation--validate"
                    sx={{ marginTop: "1.3rem" }}
                    value="Valider"
                    onClick={
                        chosenCard ? () => validateCard(chosenCard) : undefined
                    }
                />
            </Box>
        </RfidActivationLayout>
    )
}
